import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth, OAuthProvider } from 'firebase/auth';

const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

// Microsoft / Entra ID provider. The tenant id restricts sign-in to the
// Altyor Entra tenant only — non-Altyor Microsoft accounts are rejected
// at the OIDC step.
export function microsoftProvider() {
  const provider = new OAuthProvider('microsoft.com');
  const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
  if (tenantId) {
    provider.setCustomParameters({ tenant: tenantId });
  }
  provider.addScope('openid');
  provider.addScope('email');
  provider.addScope('profile');
  return provider;
}
